// extracted by mini-css-extract-plugin
export var caption = "ScientistHero-module--caption--20b2d";
export var clickable = "ScientistHero-module--clickable--34a76";
export var container = "ScientistHero-module--container--fc03c";
export var content = "ScientistHero-module--content--cbb51";
export var contentCategory = "ScientistHero-module--contentCategory--fdc3b";
export var date = "ScientistHero-module--date--0d5b2";
export var image = "ScientistHero-module--image--7bea1";
export var scientistHero = "ScientistHero-module--scientistHero--3798a";
export var text = "ScientistHero-module--text--562b7";